const BCCCWebsiteGameWathcer = [
  "HTML",
  "CSS",
  "JavaScript",
  "API",
  "Battlezone",
  "Github Pages",
];
const BZCCStats = ["Python", "API", "JSON", "Statistics", "Battlezone"];

const PortfolioWeb = [
  "JavaScript",
  "CSS",
  "SCSS",
  "HTML",
  "React",
  "Github Pages",
];
const MineCraftBot = ["Python", "PyQt5", "win32com", "rcon", "Discord API"];
const D2PServerUpdate = ["HTML", "paintball2", "documentation"];
const MacroPad = ["Python", "circuitpython", "macropad", "media", "capture"];
const BZCCEditor = ["Python", "Steam", "Battlezone"];
const RosterBorad = ["Python", "Slack"];
const CurrencyConverter = ["Java", "Android", "API"];
const SSMTPMessenger = ["Python", "SSMTP", "SMS", "GMAIL"];
const BZCCLostMissions = ["Lua", "AIP", "BZN", "Battlezone"];
const GortBot = ["JavaScript", "Discord", "API", "Heroku", "SQL"];
const GonzalesApp = ["Java", "Android"];
const BZCCColorSelector = ["Lua", "Battlezone", "Steam", "BZN"];
const PingTool = ["Python", "Tkinter", "Command Prompt"];
const HoverTankGame = ["C#", "Unity", "3D"];

const ProjectTagContainer = [
  BCCCWebsiteGameWathcer,
  BZCCStats,
  PortfolioWeb,
  MineCraftBot,
  D2PServerUpdate,
  MacroPad,
  BZCCEditor,
  RosterBorad,
  CurrencyConverter,
  SSMTPMessenger,
  BZCCLostMissions,
  GortBot,
  GonzalesApp,
  BZCCColorSelector,
  PingTool,
  HoverTankGame,
];

export { ProjectTagContainer };
